import { render } from "./SearchWordsForm.vue?vue&type=template&id=450955c1"
import script from "./SearchWordsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchWordsForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/search-words/components/SearchWordsForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "450955c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('450955c1', __exports__)) {
    api.reload('450955c1', __exports__)
  }
  
  module.hot.accept("./SearchWordsForm.vue?vue&type=template&id=450955c1", () => {
    api.rerender('450955c1', render)
  })

}


export default __exports__